import toUpper from 'lodash/toUpper';
import get from 'lodash/get';
import filter from 'lodash/filter';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import { PLCC, DC } from 'yoda-checkout-components/lib/common/Constants';

const isJcpCardInOrder = (cardType) =>
    toUpper(cardType) === PLCC || toUpper(cardType) === DC || false;

const getExpiry = (dataItem) => {
    const validTill = get(dataItem, 'validTil', '');
    const expiry = validTill.split('THROUGH ')[1];
    const offerEndDate = new Date(expiry);
    const month = `0${offerEndDate.getMonth() + 1}`.slice(-2);
    const date = `0${offerEndDate.getDate()}`.slice(-2);
    const year = offerEndDate.getFullYear();
    const expiryDate = `${month}/${date}/${year}`;
    return expiryDate;
};

const getCouponModalInfo = (dataItem) => {
    const channelType = get(dataItem, 'channel.type', '');
    const redeemingChannel =
        !isEmpty(channelType) && channelType === 'all'
            ? 'ONLINE & IN-STORE'
            : `${channelType} ONLY`;
    const offerItems = get(dataItem, 'offers[0].data', []);
    const headLineText = get(dataItem, 'offers[0].data[0].name', '');
    const description = get(dataItem, 'offers[0].data[0].description', '');
    const conjunction = get(dataItem, 'offers[0].data[1].conjunction', 'OR');
    const expiryDate = getExpiry(dataItem);
    return {
        channelType,
        redeemingChannel,
        offerItems,
        headLineText,
        description,
        conjunction,
        expiryDate,
    };
};

const getDeliveryChangedItems = (items, deliveryChangedIds) => {
    return filter(items, (item) => includes(deliveryChangedIds, item.id));
};
/* istanbul ignore next */
const buildMetaATCPayload = (urlProducts, SkuIdLength) => {
    // Default Parameters to send
    const deliveryOption = { type: 'HOME', selected: true, label: 'Store' };
    const childItems = [];

    const validData = [];
    const invalidEntries = [];

    urlProducts?.split(',').forEach((pair) => {
        const [skuPart, quantity] = pair?.split(':');
        const [skuId, ppId] = skuPart?.split('-');

        if (skuId?.length > SkuIdLength || !ppId?.length > 20) {
            invalidEntries.push({ skuPart, quantity });
            return;
        }

        validData.push({ skuId, ppId, quantity, deliveryOption, childItems });
    });

    const result = {
        payload:
            validData.length > 0
                ? { data: validData, xClientSource: 'META_CART', source: 'meta' }
                : null,
        invalidEntries,
    };

    return result;
};

const isInstagramOrFacebookUserAgent = (userAgent, metaUAPatterns) => {
    if (metaUAPatterns.length > 0) {
        const isMetaUA = metaUAPatterns.some((pattern) => new RegExp(pattern, 'i').test(userAgent));
        return isMetaUA ? true : 'userAgentNotFound';
    }
    return 'userAgentNotFound'; // the string "userAgentNotFound" is for logging
};
/* istanbul ignore next */
const isFromMetaPlatform = (context = {}) => {
    const {
        query: { products } = {},
        requestUrl = '',
        headers = {},
        preferences: { metaUAPattern = [] } = {},
        featureFlags: { enableMetaSocialSelling = true } = {},
    } = context;
    if (!enableMetaSocialSelling) {
        return { isFromMeta: false, isMetaUANotFound: false };
    }
    const isMetaUA = isInstagramOrFacebookUserAgent(headers?.['user-agent'], metaUAPattern);
    /** check if
     * request from /cart/meta
     * it has products queryParam
     * If metaUAPattern config has values, return true based on UAPattern, else consider as true(indicator string) pass the flow but log the UA details
     * If metaUAPattern config is empty, assume request is from Meta platform and return indicator string for logging */
    return {
        isFromMeta: !!(requestUrl === '/cart/meta' && products && isMetaUA),
        isMetaUANotFound:
            requestUrl === '/cart/meta' && products && isMetaUA === 'userAgentNotFound',
    };
};
export default {
    isJcpCardInOrder,
    getCouponModalInfo,
    getExpiry,
    getDeliveryChangedItems,
    buildMetaATCPayload,
    isFromMetaPlatform,
};
